import { useAuth0 } from '@auth0/auth0-react';
import { AuthUser } from '../../utils/user';
import { getConfig } from '../../utils/config';
import { useEffect } from 'react';
import { setSentryUser } from '../../utils/sentry';
import { useSchool } from 'contexts/SchoolContext';

export const useSentry = () => {
  const { user } = useAuth0<AuthUser>();
  const { environment, sentryDsn } = getConfig();
  const {
    state: { school },
  } = useSchool();
  const schoolName = school?.name ?? '';

  useEffect(() => {
    if (environment === 'local' || !user || !sentryDsn) {
      return;
    }

    setSentryUser(user, schoolName);
  }, [environment, schoolName, sentryDsn, user]);
};
